import React from "react";
import { StyledCol, StyledTableRow } from "../../../styles/styledTable";
import { StyledBreakWord } from "../../../styles/styledBreakWord";

const TelegramBotsItem = ({ bot, onDelete, t }) => (
  <StyledTableRow scroll="auto" col="3" className="bot-list__row">
    <StyledCol data-title={t("bots.table.project")}>
      {bot.projectName}
    </StyledCol>
    <StyledCol data-title={t("bots.table.token")}>
      <StyledBreakWord as="p">
        {bot.tokenMasked}
      </StyledBreakWord>
    </StyledCol>
    <StyledCol data-title={t("bots.table.actions")}>
      <button className="table-action table-action_danger" onClick={() => onDelete(bot.projectId)}>
        <span className="icon-light-trash" />
        {t("common.delete")}
      </button>
    </StyledCol>
  </StyledTableRow>
);

export default TelegramBotsItem;